function toggleSwatches(containerId) {
    var container = document.getElementById(containerId);
    var swatches = container.querySelectorAll('.hidden-swatch');
    var button = container.nextElementSibling;

    swatches.forEach(function(swatch) {
      if (swatch.style.display === 'none' || swatch.style.display === '') {
        swatch.style.display = 'block';
        button.textContent = 'View Less';
      } else {
        swatch.style.display = 'none';
        button.textContent = 'View More';
      }
    });
}
